import { render, staticRenderFns } from "./HorizontalBarChartSimple.vue?vue&type=template&id=60669b2a&scoped=true"
import script from "./HorizontalBarChartSimple.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChartSimple.vue?vue&type=script&lang=js"
import style0 from "./HorizontalBarChartSimple.vue?vue&type=style&index=0&id=60669b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60669b2a",
  null
  
)

export default component.exports